<div [className]="'tbl' + (noMargin ? '  tbl--no-margin' : '') + (hasXScroll ? '  tbl--has-overflow' : '') + ('  table  table-sm  table-striped  table-hover') + ' ' + (additionalClasses ? additionalClasses : '')" #tableWrapper>
    <table [className]="'tbl__table' + (autoSizeFirstColumn ? '  tbl__table--has-selection' : '') + (autoSizeLastColumn ? '  tbl__table--has-utilities' : '')">
        <ng-content></ng-content>
    </table>
</div>
